import { Col } from '@guestyci/foundation/Layout';
import Spinner from '@guestyci/foundation/Spinner';
import createStyles from '@guestyci/foundation/createStyles';

export const useStyles = createStyles({
  loadingRoot: {
    display: 'flex',
    minHeight: 150,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const PageLoadingSpinner = () => {
  const classes = useStyles();
  return (
    <Col spacing={2} className={classes.loadingRoot} data-qa="loading-spinner">
      <div>
        <Spinner size={30} />
      </div>
    </Col>
  );
};

export default PageLoadingSpinner;
